import React, { useState, useEffect } from "react";
import { Response, ClientInfo } from "@blisspointmedia/bpm-types/dist/Onboarding";
import WidgetContainer from "../../Components/WidgetContainer";
import { platformBudgetsOptions } from "./PlatformBudgetsOptions";
import OnboardingFreeForm from "../OnboardingFreeForm";
import { getCompletedPlatformPercentage } from "../OnboardingUtils";
import { ClientInfoComponentProps } from "../ClientInfo";

const PlatformBudgets: React.FC<ClientInfoComponentProps> = ({
  clientInfo,
  onPercentageChange,
  onClientInfoChange,
}) => {
  const [allResponses, setAllResponses] = useState<ClientInfo>(clientInfo);

  const platformOptions = platformBudgetsOptions(allResponses.responses);

  useEffect(() => {
    const totalPercentage = getCompletedPlatformPercentage(allResponses.responses, platformOptions);
    onPercentageChange(totalPercentage);
  }, [allResponses.responses, onPercentageChange, platformOptions]);

  const handlePlatformBudgetsChange = (updatedResponses: Response[]) => {
    const updatedClientInfo = {
      ...allResponses,
      responses: updatedResponses,
    };
    setAllResponses(updatedClientInfo);
    onClientInfoChange(updatedClientInfo);
  };

  const platformForm = (key: string, option) => {
    return (
      <div>
        <OnboardingFreeForm
          questions={option.table}
          responses={allResponses.responses}
          onDataChange={handlePlatformBudgetsChange}
        />
      </div>
    );
  };

  return (
    <div>
      {Object.keys(platformOptions).map(key => {
        const disabled = platformOptions[key].table.rows.length === 0;
        return (
          <WidgetContainer
            key={key}
            backgroundColor="white"
            header={platformOptions[key].title}
            design="secondary"
            disabled={disabled}
            collapsible
            startOpen={false}
          >
            {platformForm(key, platformOptions[key])}
          </WidgetContainer>
        );
      })}
    </div>
  );
};

export default PlatformBudgets;
